import { Box, Button, Grid, Tab, Tabs, Typography } from '@mui/material';
import { GridSelectionModel } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { BEEScorecardUserAccessService } from '../../../../Component/Api/BBEScorecardUserAccess/BEEScorecardUserAccessService';
import { MyBEE123HomepageService } from '../../../../Component/Api/MyBEE123HomePage/MyBEE123HomepageService';
import { UserService } from '../../../../Component/Api/User/UserService';
import AppAccordion from '../../../../Component/Common/Components/Accordion/AppAccordion';
import { SmallLoading } from '../../../../Component/Common/Components/Loading/IntermediateLoading';
import { BEEScorecardUserAccess } from '../../../../Component/Model/Dto/Scorecard/BEEScorecardUserAccessDto';
import { ScorecardMeta } from '../../../../Component/Model/Dto/Scorecard/ScorecardMeta';
import { UserDto } from '../../../../Component/Model/Dto/User';
import { ModuleType } from '../../../../Component/Model/Enum/BEE123Enums';
import { isNullOrEmpty } from '../../../../Component/Model/helpers';
import { UserAtom } from '../../../../State/user.Atom';
import { TabPanel, tabPropsFunc } from '../../Account/Account';
import { UserDataTable } from '../UserDataTable';
import { BEEUserScorecardDataGrid, EEUserScorecardDataGrid } from '../UserScorecardDataColumns';
import { UserRolesDataTable } from './UserRolesDataTable';
import { EE123DisplayName, EmployeeHubRoles, EmploymentEquity, GeneralAndFeatures, Platform, RevisedCodes_ScorecardElements, SectorSpecificScorecardElements, SiteAdminRoles } from '../../../../Component/Common/Constants/Constants';
import config from '../../../../config';

interface IUserRolesParams {
    id: string
};

export const UserRolesPage = () => {
    const { id } = useParams<IUserRolesParams>();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [name, setName] = useState("");
    const currentUser = useRecoilValue(UserAtom);

    const [BEEUserScorecardData, setBEEUserScorecardData] = useState<ScorecardMeta.ScorecardMetaViewModel[]>([]);
    const [BEEScorecardSelectionModel, setBEEScorecardSelectionModel] = useState<GridSelectionModel>([]);

    const [EEScorecardSelectionModel, setEEScorecardSelectionModel] = useState<GridSelectionModel>([]);
    const [EEUserScorecardData, setEEUserScorecardData] = useState<ScorecardMeta.ScorecardMetaViewModel[]>([]);

    const [allGeneralRoles, setAllGeneralRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [allRevisedRoles, setAllRevisedRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [allSectorRoles, setAllSectorRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [allEERoles, setAllEERoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [EE123Role, setEE23Role] = useState<UserDto.UserRoleViewModel>();
    const [allPlatformRoles, setAllPlatformRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [allEmployeeHubRoles, setAllEmployeeHubRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [allSiteAdminRoles, setAllSiteAdminRoles] = useState<UserDto.UserRoleViewModel[]>([]);

    const [userGeneralRoles, setUserGeneralRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [userRevisedRoles, setUserRevisedRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [userSectorRoles, setUserSectorRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [userEERoles, setUserEERoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [userPlatformRoles, setUserPlatformRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [userEmployeeHubRoles, setUserEmployeeHubRoles] = useState<UserDto.UserRoleViewModel[]>([]);
    const [userSiteAdminRoles, setUserSiteAdminRoles] = useState<UserDto.UserRoleViewModel[]>([]);

    const [tabValue, setTabValue] = useState<number>(0);
    const allowedGeneralAndFeaturesVaClientPermissions = ['General Information', 'Empowering Supplier', 'People', 'Salaries', 'Y.E.S. Initiative'];
    const removeGeneralAndFeaturesVaPermissions = ['BEE123Consolidation.edit'];
    const [isClientUser, setIsClientUser] = useState<boolean>(false);
    const [isAuditUser, setIsAuditUser] = useState<boolean>(false);
    const [isVAUser, setIsVAUser] = useState<boolean>(false);
    const [isRolesEditable, setIsRolesEditable] = useState<boolean>(true);

    const [isAdminUser, setIsAdminUser] = useState<boolean>(false);
    const [isSubAdminUser, setIsSubAdminUser] = useState<boolean>(false);
    
    const isEmployeeHubRegistration = config.advisory_registration_id.toLocaleLowerCase() === currentUser.registrationId.toLocaleLowerCase();
        
    const handleTabValueChanged = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    }

    const fetchBEEUserScorecards = async () => {
        try {
            let response = await MyBEE123HomepageService.getBEEUserScorecards();
            setBEEUserScorecardData(response.data);
            fetchSelectedScorecardIds(ModuleType.BEE_Module);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchEEUserScorecards = async () => {
        try {
            let response = await MyBEE123HomepageService.getEEUserScorecards();
            setEEUserScorecardData(response.data);
            fetchSelectedScorecardIds(ModuleType.Employment_Equity_Module);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchSelectedScorecardIds = async (moduleType: ModuleType) => {
        switch (moduleType) {
            case ModuleType.Employment_Equity_Module:
                try {
                    const response = await BEEScorecardUserAccessService.getEEScorecardUserAccess(id!);
                    setEEScorecardSelectionModel([...response.data]);
                } catch (error) {
                    console.log(error);
                }
                break;
            case ModuleType.BEE_Module:
                try {
                    const response = await BEEScorecardUserAccessService.getBEEScorecardUserAccess(id!);
                    setBEEScorecardSelectionModel([...response.data]);
                } catch (error) {
                    console.log(error);
                }
                break;
            default:
                break;
        }
    }

    const getUserRoles = async () => {
        let isClientRole = false;
        let isAuditRole = false;
        try {
            let response = await UserService.getUserRoles(id!);
            setName(response.data.Name);

            let clientRole = response.data.Roles.find(item => item.Name.toLowerCase() === 'client');
            if (clientRole !== undefined) {
                isClientRole = true;
                setIsClientUser(isClientRole);
            }

            let adminUserRole = response.data.Roles.find(item => item.Name.toLowerCase() === 'useradmin');
            if (adminUserRole !== undefined) {
                setIsAdminUser(true);
            }

            let subAdminUserRole = response.data.Roles.find(item => item.Name.toLowerCase() === 'subadmin');
            if (subAdminUserRole !== undefined) {
                setIsSubAdminUser(true);
            }

            let auditUserRole = response.data.Roles.find(item => item.Name.toLowerCase() === 'audit');
            if (auditUserRole !== undefined) {
                isAuditRole = true;
                setIsAuditUser(true);
            }

            let vaUser = response.data.Roles.find(item => item.Name.toLowerCase() === 'vauser');
            if (vaUser !== undefined) {
                setIsVAUser(true);
            }

            let selectedGeneralData = response.data.Roles.filter(item => item.RoleGroup === GeneralAndFeatures);
            let selectedRevisedCodesData = response.data.Roles.filter(item => item.RoleGroup === RevisedCodes_ScorecardElements);
            let selectedSectorSpecificData = response.data.Roles.filter(item => item.RoleGroup === SectorSpecificScorecardElements);
            let selectedEERoleData = response.data.Roles.filter(item => item.RoleGroup === EmploymentEquity && item.DisplayName !== EE123DisplayName);
            let selectedPlatformRole = response.data.Roles.filter(item => item.RoleGroup === Platform);
            let selectedBEE123RoleData = response.data.Roles.filter(item => item.RoleGroup === EmployeeHubRoles);
            let selectedSiteAdminRoleData = response.data.Roles.filter(item => item.RoleGroup === SiteAdminRoles);

            setUserGeneralRoles(selectedGeneralData);
            setUserRevisedRoles(selectedRevisedCodesData);
            setUserSectorRoles(selectedSectorSpecificData);
            setUserEERoles(selectedEERoleData);
            setUserPlatformRoles(selectedPlatformRole);
            setIsRolesEditable(response.data.IsRolesEditable);
            setUserEmployeeHubRoles(selectedBEE123RoleData);
            setUserSiteAdminRoles(selectedSiteAdminRoleData);
        } catch (error) {
            console.log(error);
        }
        getAllRoles(isClientRole, isAuditRole);
    }

    const getAllRoles = async (isClientRole: boolean, isAuditRole: boolean) => {
        try {
            let response = await UserService.getAllRoles();

            let generalData = response.data.filter(item => item.RoleGroup === GeneralAndFeatures);
            let revisedCodesData = response.data.filter(item => item.RoleGroup === RevisedCodes_ScorecardElements);
            let sectorSpecificData = response.data.filter(item => item.RoleGroup === SectorSpecificScorecardElements);
            let eeRoleData = response.data.filter(item => item.RoleGroup === EmploymentEquity);
            let platformRoleData = response.data.filter(item => item.RoleGroup === Platform);
            let employeeHubRoleData = response.data.filter(item => item.RoleGroup === EmployeeHubRoles)
            let siteAdminRoleData = response.data.filter(item => item.RoleGroup === SiteAdminRoles && item.Name !== 'SupportUser' && item.Name !== 'SiteAdministration');

            setAllPlatformRoles(platformRoleData);

            let ee123Role = eeRoleData.find(item => item.DisplayName === EE123DisplayName)!;
            setEE23Role(ee123Role);
            eeRoleData = eeRoleData.filter(item => item.DisplayName !== EE123DisplayName);

            if(isAuditRole)
            {
                generalData = generalData.filter(item => !removeGeneralAndFeaturesVaPermissions.includes(item.Name));
            }

            if (isClientRole) {
                generalData = generalData.filter(item => allowedGeneralAndFeaturesVaClientPermissions.includes(item.DisplayName));
            }

            setAllGeneralRoles(generalData);
            setAllRevisedRoles(revisedCodesData);
            setAllSectorRoles(sectorSpecificData);
            setAllEERoles(eeRoleData);
            setAllEmployeeHubRoles(employeeHubRoleData);
            setAllSiteAdminRoles(siteAdminRoleData);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            await Promise.all([
                getUserRoles(),
                fetchBEEUserScorecards(),
                fetchEEUserScorecards()
            ]);
        } catch {
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (isNullOrEmpty(id)) {
            history.push("/");
            toast.error('No user selected');
        } else {
            fetchData();
        }
    }, [id]);

    const saveUserSelectedRoles = async (userId: string): Promise<boolean> => {

        let selectedRoles: UserDto.UserRoleViewModel[] = [];
        selectedRoles.push(...userGeneralRoles);
        selectedRoles.push(...userRevisedRoles);
        selectedRoles.push(...userSectorRoles);
        selectedRoles.push(...userEERoles);
        selectedRoles.push(...userPlatformRoles);
        selectedRoles.push(...userEmployeeHubRoles);
        selectedRoles.push(...userSiteAdminRoles);

        if (EEScorecardSelectionModel?.length > 0 && EE123Role != null) {
            selectedRoles.push(EE123Role);
        }

        const userRoleUpdateRequest: UserDto.UserRoleUpdateViewModel = {
            UserId: userId,
            UserRoles: selectedRoles
        }

        try {
            await UserService.saveUserRoles(userRoleUpdateRequest);
            toast.success('User Roles Saved');
            return true;
        } catch (error) {
            console.log(error);
        }
        return false;
    }

    const saveUserSelectedScorecards = async (userId: string): Promise<boolean> => {
        let selectedScorecardIds: string[] = [];
        selectedScorecardIds.push.apply(selectedScorecardIds, BEEScorecardSelectionModel.map(item => item.toString()));
        selectedScorecardIds.push.apply(selectedScorecardIds, EEScorecardSelectionModel.map(item => item.toString()));

        let request: BEEScorecardUserAccess.Request = {
            UserId: userId,
            BEEScorecardIdList: selectedScorecardIds
        }
        try {
            await BEEScorecardUserAccessService.addScorecardUserAccess(request);
            toast.success('Scorecard Access Saved');
            return true;
        } catch (error) {
            console.log(error);
        }
        return false;
    }

    const saveUserData = async () => {
        let userId = id!;
        setIsSaving(true);
        try {
            const userRolesSaveResponse = await saveUserSelectedRoles(userId);
            const userScorecardSaveResponse = await saveUserSelectedScorecards(userId);

            if (userRolesSaveResponse && userScorecardSaveResponse) {
                history.push('/userManagement');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSaving(false);
        }
    }

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '75vh',
            }}>
                <SmallLoading />
            </div>
        )
    }
    return (
        <div>
            <Typography mb={1}>
                User Roles - {name}
            </Typography>

            {isAdminUser &&
                <Typography mb={1} fontSize={14}>
                    N.B. As an admin user, you have access to all scorecards and roles.
                </Typography>
            }

            <Grid container spacing={1}>
                {!currentUser.hasAuditRole && !currentUser.isClientAdmin && !isEmployeeHubRegistration && !isVAUser &&
                    <Grid item xs={12}>
                        {config.enable_WSPATR === 'true' &&
                            <AppAccordion label='Platform Module' expandOnDefault={false}>
                                <Typography variant='h5' mb={1}>
                                    Roles
                                </Typography>
                                <Box>
                                    <UserRolesDataTable
                                        allRoles={allPlatformRoles}
                                        userRoles={userPlatformRoles}
                                        setUserRoles={setUserPlatformRoles}
                                        isRolesEditable={isRolesEditable}
                                        isAdminRoleUser={isAdminUser}
                                    />
                                </Box>
                            </AppAccordion>
                        }
                    </Grid>
                }

                {isEmployeeHubRegistration &&
                    <>
                    <Grid item xs={12}>
                        <AppAccordion label='Employee Roles' expandOnDefault={false}>
                            <Typography variant='h5' mb={1}>
                                BEE123 Employee Roles
                            </Typography>
                            <Box>
                                <UserRolesDataTable
                                    allRoles={allEmployeeHubRoles}
                                    userRoles={userEmployeeHubRoles}
                                    setUserRoles={setUserEmployeeHubRoles}
                                    isRolesEditable={true}
                                    isAdminRoleUser={isAdminUser}
                                    showHasAccessView={isEmployeeHubRegistration}
                                    isEmployeeHubRoles={true}
                                    userId={id!} />
                            </Box>
                        </AppAccordion>
                    </Grid>
                    <Grid item xs={12}>
                        <AppAccordion label='Site Admin Roles' expandOnDefault={false}>
                            <Typography variant='h5' mb={1}>
                                Site Admin Roles
                            </Typography>
                            <Box>
                                <UserRolesDataTable
                                    allRoles={allSiteAdminRoles}
                                    userRoles={userSiteAdminRoles}
                                    setUserRoles={setUserSiteAdminRoles}
                                    isRolesEditable={true}
                                    isAdminRoleUser={isAdminUser} />
                            </Box>
                        </AppAccordion>
                    </Grid>
                    </>
                }

                <Grid item xs={12}>
                    <AppAccordion label='BEE Module' expandOnDefault={false}>
                        {!isEmployeeHubRegistration &&
                            <>
                                <Typography variant='h5' mb={1}>
                                    Scorecard Access
                                </Typography>
                                <UserDataTable
                                    columns={BEEUserScorecardDataGrid.columns}
                                    isLoading={isLoading}
                                    rows={BEEUserScorecardData}
                                    selectionModel={!isAdminUser ? BEEScorecardSelectionModel : []}
                                    setSelectionModel={setBEEScorecardSelectionModel}
                                    pageSize={10}
                                    checkboxSelection={!isAdminUser} />
                                <br />
                            </>   
                        }

                        <Typography variant='h5' mb={1}>
                            Roles
                        </Typography>
                        <Tabs value={tabValue} onChange={handleTabValueChanged} aria-label="TabswithIcons" centered>
                            <Tab label="General & Features" {...tabPropsFunc(0)} />
                            <Tab label="Revised Codes - Scorecard Elements" {...tabPropsFunc(1)} />
                            <Tab label="Sector Specific Scorecard Elements" {...tabPropsFunc(2)} />
                        </Tabs>
                        <TabPanel value={tabValue} index={0}>
                            <UserRolesDataTable
                                allRoles={allGeneralRoles}
                                userRoles={userGeneralRoles}
                                setUserRoles={setUserGeneralRoles}
                                showHasAccessView={isClientUser}
                                isRolesEditable={isRolesEditable}
                                isAdminRoleUser={isAdminUser}
                                isSubAdminUser={isSubAdminUser}
                            />
                        </TabPanel>
                        <TabPanel value={tabValue} index={1}>
                            <UserRolesDataTable
                                allRoles={allRevisedRoles}
                                userRoles={userRevisedRoles}
                                setUserRoles={setUserRevisedRoles}
                                showHasAccessView={isClientUser}
                                isRolesEditable={isRolesEditable}
                                isAdminRoleUser={isAdminUser}
                            />
                        </TabPanel>
                        <TabPanel value={tabValue} index={2}>
                            <UserRolesDataTable
                                allRoles={allSectorRoles}
                                userRoles={userSectorRoles}
                                setUserRoles={setUserSectorRoles}
                                showHasAccessView={isClientUser}
                                isRolesEditable={isRolesEditable}
                                isAdminRoleUser={isAdminUser}
                            />
                        </TabPanel>
                    </AppAccordion>
                </Grid>

                {!currentUser.hasAuditRole && !currentUser.isClientAdmin && !isEmployeeHubRegistration && !isVAUser &&
                    <Grid item xs={12}>
                        <AppAccordion label='Employment Equity Module' expandOnDefault={false}>
                            <Typography variant='h5' mb={1}>
                                Scorecard Access
                            </Typography>
                            <UserDataTable
                                columns={EEUserScorecardDataGrid.columns}
                                isLoading={isLoading}
                                rows={EEUserScorecardData}
                                selectionModel={!isAdminUser ? EEScorecardSelectionModel : []}
                                setSelectionModel={setEEScorecardSelectionModel}
                                pageSize={10}
                                checkboxSelection={!isAdminUser}
                            />

                            <br />
                            <Typography variant='h5' mb={1}>
                                Roles
                            </Typography>
                            <Box>
                                <UserRolesDataTable
                                    allRoles={allEERoles}
                                    userRoles={userEERoles}
                                    setUserRoles={setUserEERoles}
                                    isRolesEditable={isRolesEditable}
                                    isAdminRoleUser={isAdminUser}
                                />
                            </Box>
                        </AppAccordion>
                    </Grid>
                }
                <Grid item xs={12} mt={1} display='flex'>
                    <Box mr={1} sx={{ width: 150 }}>
                        <Button variant='contained' color='primary' fullWidth onClick={saveUserData} disabled={isSaving}>Save</Button>
                    </Box>
                    <Box sx={{ width: 150 }}>
                        <Button variant='contained' color='secondary' fullWidth onClick={() => history.push('/userManagement')}>Cancel</Button>
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}
